import React, {Fragment} from 'react';
import {CurrencyConstants, Money} from "finhelper"
import {Img, RowWrapper} from "../style";
import {Td as TableTd} from '#app/components/Table/styles';
import {OperationSizeConstants} from "#app/pages/IncomeAndExpenses/components/BaseOperationList/OperationSizeConstants";
import {useTableContext} from "#app/pages/IncomeAndExpenses/components/TableProvider";

const Date = ({year, month, date, isNotVisibleSum, currencyId, children}) => {
  const { toggle, isOpened } = useTableContext();

  const id = year.name + month.name + date.name


  return <Fragment>
    <RowWrapper border>
      <TableTd flexWidth='2%'>
        <Img
          id={'arrow-date-' + year.name + '-' + month.nameEng + '-' + date.nameEng.replace(/\s/g,'')}
          className={isOpened(id) ? 'rotated' : ''}
          onClick={() => {
            toggle(id)
          }}
          src={require('#app/assets/icons/ic_dropdown.svg')}
          alt=''
        />
      </TableTd>
      <TableTd flexWidth={OperationSizeConstants.dateCellWidth}><span style={{
        cursor: 'pointer',
        display: 'inline-block',
        width: 'auto'
      }} onClick={() => {
        toggle(!isOpened)
      }}>{date.name}</span></TableTd>
      <TableTd flexWidth={OperationSizeConstants.editCellWidth}/>
      <TableTd flexWidth={OperationSizeConstants.sumCellWidth}>{isNotVisibleSum ? '******' : Money.format(Math.abs(date.sum)) + ' ' + CurrencyConstants.getCurrencySignById(currencyId)}</TableTd>
      <TableTd flexWidth={OperationSizeConstants.categoryCellWidth}/>
      <TableTd flexWidth={OperationSizeConstants.subcategoryCellWidth}/>
      <TableTd flexWidth={OperationSizeConstants.tagCellWidth}/>
      <TableTd flexWidth={OperationSizeConstants.descCellWidth}/>
      <TableTd flexWidth={OperationSizeConstants.accountCellWidth}/>
    </RowWrapper>
    {isOpened(id) && children}
  </Fragment>
}

export default Date